import { axios } from 'lib'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'

interface AttachFilesData {
  files: string[]
  description?: string
  orderId?: string | null
  proposalId?: string | null
}

const attachFiles = async (data: AttachFilesData): Promise<any> => {
  if (data.orderId) {
    return axios.post(`orders/${data.orderId}/attachments`, data)
  } else if (data.proposalId) {
    return axios.post(`orders/${data.proposalId}/attachments`, data)
  } else {
    throw new Error('Either orderId or proposalId must be provided')
  }
}

export function useAttachFiles() {
  const queryClient = useQueryClient()

  return useMutation(attachFiles, {
    onSuccess: () => {
      queryClient.invalidateQueries('orders')
      queryClient.invalidateQueries('orderActions')
      queryClient.invalidateQueries('loadOrderAttachments')
      queryClient.invalidateQueries('loadProposalAttachments')

      toast.success('Arquivos anexados com sucesso!', {
        toastId: 'attachFiles'
      })
    },
    onError: (error: unknown) => {
      console.error(error)

      toast.error('Não foi possível anexar os arquivos!', {
        toastId: 'attachFiles'
      })
    }
  })
}
